import React from 'react';
import { Link } from 'react-router-dom';

function LandingPage() {
  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      fontFamily: 'system-ui, -apple-system, sans-serif',
      background: '#fafafa',
      padding: '2rem',
    }}>
      <h1 style={{ fontSize: '3rem', fontWeight: 700, marginBottom: '0.5rem', color: '#111' }}>
        ViGR
      </h1>
      <p style={{ fontSize: '1.1rem', color: '#666', marginBottom: '3rem', textAlign: 'center', maxWidth: 500 }}>
        Visual Grammar — tools for composing and annotating scene layouts
      </p>

      <div style={{ display: 'flex', gap: '2rem', flexWrap: 'wrap', justifyContent: 'center' }}>
        <Link to="/generate" style={{ textDecoration: 'none' }}>
          <div style={{
            width: 280, padding: '2rem', borderRadius: 12,
            background: 'white', border: '1px solid #e0e0e0',
            cursor: 'pointer', transition: 'box-shadow 0.2s, transform 0.2s',
          }}
          onMouseEnter={e => { e.currentTarget.style.boxShadow = '0 4px 20px rgba(0,0,0,0.1)'; e.currentTarget.style.transform = 'translateY(-2px)'; }}
          onMouseLeave={e => { e.currentTarget.style.boxShadow = 'none'; e.currentTarget.style.transform = 'none'; }}
          >
            <div style={{ fontSize: '2rem', marginBottom: '0.75rem' }}>🎨</div>
            <h2 style={{ fontSize: '1.3rem', fontWeight: 600, color: '#111', marginBottom: '0.5rem' }}>Generate</h2>
            <p style={{ fontSize: '0.9rem', color: '#888', lineHeight: 1.5 }}>
              Create and edit scenes using image search, inpainting, and composition tools.
            </p>
          </div>
        </Link>

        <Link to="/annotate" style={{ textDecoration: 'none' }}>
          <div style={{
            width: 280, padding: '2rem', borderRadius: 12,
            background: 'white', border: '1px solid #e0e0e0',
            cursor: 'pointer', transition: 'box-shadow 0.2s, transform 0.2s',
          }}
          onMouseEnter={e => { e.currentTarget.style.boxShadow = '0 4px 20px rgba(0,0,0,0.1)'; e.currentTarget.style.transform = 'translateY(-2px)'; }}
          onMouseLeave={e => { e.currentTarget.style.boxShadow = 'none'; e.currentTarget.style.transform = 'none'; }}
          >
            <div style={{ fontSize: '2rem', marginBottom: '0.75rem' }}>📋</div>
            <h2 style={{ fontSize: '1.3rem', fontWeight: 600, color: '#111', marginBottom: '0.5rem' }}>Annotate</h2>
            <p style={{ fontSize: '0.9rem', color: '#888', lineHeight: 1.5 }}>
              Label scene compositions as good or bad. Drag objects to improve layouts.
            </p>
          </div>
        </Link>
      </div>
    </div>
  );
}

export default LandingPage;
